__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) { return typeof console !== "undefined" && console.warn && console.warn(msg); };
	var uniqueName = "health-cabin-web";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@emotion/react", "11.10.5", function() { return Promise.all([__webpack_require__.e(10), __webpack_require__.e(307), __webpack_require__.e(416)]).then(function() { return function() { return __webpack_require__(8307); }; }); });
			register("@emotion/styled", "11.10.5", function() { return Promise.all([__webpack_require__.e(416), __webpack_require__.e(82), __webpack_require__.e(225)]).then(function() { return function() { return __webpack_require__(225); }; }); });
			register("@mui/material", "5.10.13", function() { return Promise.all([__webpack_require__.e(10), __webpack_require__.e(697), __webpack_require__.e(416), __webpack_require__.e(51), __webpack_require__.e(82), __webpack_require__.e(945), __webpack_require__.e(165)]).then(function() { return function() { return __webpack_require__(1697); }; }); });
			register("axios", "1.3.2", function() { return Promise.all([__webpack_require__.e(834), __webpack_require__.e(678)]).then(function() { return function() { return __webpack_require__(8834); }; }); });
			register("jwt-decode", "3.1.2", function() { return __webpack_require__.e(456).then(function() { return function() { return __webpack_require__(456); }; }); });
			register("react-dom", "18.2.0", function() { return Promise.all([__webpack_require__.e(164), __webpack_require__.e(416)]).then(function() { return function() { return __webpack_require__(4164); }; }); });
			register("react-query", "3.39.3", function() { return Promise.all([__webpack_require__.e(933), __webpack_require__.e(416), __webpack_require__.e(51)]).then(function() { return function() { return __webpack_require__(1933); }; }); });
			register("react-router-dom", "6.4.3", function() { return Promise.all([__webpack_require__.e(478), __webpack_require__.e(416), __webpack_require__.e(8)]).then(function() { return function() { return __webpack_require__(1478); }; }); });
			register("react", "18.2.0", function() { return __webpack_require__.e(791).then(function() { return function() { return __webpack_require__(2791); }; }); });
			initExternal(5696);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};